enum SupportLanguage {
    ENG = 'eng',
    SCH = 'sch',
    TCH = 'tch',
    HKT = 'hkt',
    KR = 'ko',
    JP = 'ja',
    ID = 'id',
    ES = 'es',
    PT = 'pt',
    VI = 'vi',
    TH = 'th',
    MS = 'ms',
    FIL = 'fil',
    HI = 'hi',
    TR = 'tr',
    RU = 'ru',
    BN = 'bn',
    MY = 'my',
    DE = 'de',
}

type ChineseLanguageType = { [value in SupportLanguage]: string };

export const supportLanguageName: ChineseLanguageType = {
    [SupportLanguage.ENG]: '英文',
    [SupportLanguage.SCH]: '簡中',
    [SupportLanguage.TCH]: '繁中',
    [SupportLanguage.HKT]: '香港繁中',
    [SupportLanguage.KR]: '韓文',
    [SupportLanguage.JP]: '日文',
    [SupportLanguage.ID]: '印尼文',
    [SupportLanguage.PT]: '葡萄牙',
    [SupportLanguage.ES]: '西班牙',
    [SupportLanguage.VI]: '越南文',
    [SupportLanguage.TH]: '泰文',
    [SupportLanguage.FIL]: '菲律賓',
    [SupportLanguage.MS]: '馬來文',
    [SupportLanguage.HI]: '天城文',
    [SupportLanguage.TR]: '土耳其文',
    [SupportLanguage.RU]: '俄文',
    [SupportLanguage.BN]: '孟加拉文',
    [SupportLanguage.MY]: '緬甸文',
    [SupportLanguage.DE]: '德文',
};

namespace SupportLanguage {
    export function contains(language: string): language is SupportLanguage {
        return Object.values(SupportLanguage).includes(language as SupportLanguage);
    }
    export function getAll(): SupportLanguage[] {
        return Object.values(SupportLanguage) as SupportLanguage[];
    }
    Object.defineProperty(SupportLanguage, 'contains', {
        enumerable: false,
    });
    Object.defineProperty(SupportLanguage, 'getAll', {
        enumerable: false,
    });
}

export default SupportLanguage;
